import { CoreInitiativesCommentsByIdName } from './name';
import { coreInitiativesCommentsRemoveSyncSlice } from '../remove';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativeComment } from '@api';

export const coreInitiativesCommentsByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesCommentsRemoveSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesCommentsByIdName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeComment
});
